export default "__VITE_ASSET__BP7HPSHE__"